import React from 'react';
import AdminBattleship from '../components/AdminBattleship';
import '../styles/AdminBattleship.css';

const AdminBattleshipPage = () => {
  return (
    <div className="admin-game-page">
      <div className="admin-game-header">
        <a href="/admin/controls/battleship" className="back-link">&larr; Back to Admin Panel</a>
      </div>
      <AdminBattleship />
    </div>
  );
};

export default AdminBattleshipPage;
